module.exports = __webpack_public_path__ + "img/1580339302.ede91669.jpg";